import BookTicketContainer from "./BookTicketContainer"


const BookTicket = () => {
  return (
    <div className='page-body'>
      <BookTicketContainer />
    </div>
  )
}

export default BookTicket